export default __webpack_public_path__ + "static/初心资本-9063815ce76b5c9cf9268a7f635a9bf7.png";